import {
  getChartingResource,
  postChartingForm
} from '@/features/charting-next/api/chartingClient';

export const get = getChartingResource;
export const postForm = postChartingForm;
